/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useState} from 'react'
import {DashPageTitle} from '../../../_metronic/layout/core/DashPageData'
import {Helmet} from 'react-helmet'
import DashboardHeader from './components/headers/DashboardHeader'
import DashboardPageHeader from './components/headers/DashboardPageHeader'
import {TaskList} from './components/table/TaskList'
import useTenantCheck from '../../Hooks/useTenantCheck'
import {ToastContainer} from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import {useAuth} from '../../modules/auth'
import db from 'services/firebase'
import {collection, onSnapshot, doc} from '@firebase/firestore'
import {useNavigate} from 'react-router-dom'
import Button from 'app/components/Button'
import CustomModal from 'app/components/CustomModal'

const DashboardPage: FC = () => {
  useTenantCheck()
  const {currentUser} = useAuth()
  const [activeFrameworks, setActiveFrameworks] = useState<any[]>([])
  const navigate = useNavigate()
  const [showOnboardingModal, setShowOnboardingModal] = useState(false)

  useEffect(() => {
    getActiveFrameworks()
  }, [])

  useEffect(() => {
    let timeoutId: NodeJS.Timeout | undefined
    if (currentUser?.account_type === 'Trial' && activeFrameworks.length === 0) {
      timeoutId = setTimeout(() => {
        setShowOnboardingModal(true)
      }, 2000)
    } else {
      setShowOnboardingModal(false)
    }
    return () => {
      if (timeoutId) clearTimeout(timeoutId)
    }
  }, [currentUser, activeFrameworks])

  const getActiveFrameworks = () => {
    try {
      const tenantId = currentUser?.tenantId || ''
      const tenantRef = doc(db, 'tenants', tenantId)
      const testsCollectionRef = collection(tenantRef, 'active_frameworks')

      const unsubscribe = onSnapshot(testsCollectionRef, (snapshot) => {
        const frameworksData = snapshot.docs.map((doc) => ({
          ...doc.data(),
          id: doc.id,
          frameworks: doc.data().frameworks,
        }))
        const frameworks = frameworksData[0]?.frameworks || []
        setActiveFrameworks(frameworks)
      })

      return unsubscribe
    } catch (error) {
      console.error('Error getting frameworks:', error)
    }
  }

  return (
    <>
      <Helmet>
        <title>SecureSlate | Dashboard</title>
      </Helmet>
      <ToastContainer />

      <div style={{marginBottom: '20px'}}>
        <h3 className='fw-bold fs-3 mb-1'>Hey, {currentUser?.userName?.split(' ')[0]}!</h3>
        <p className=' fs-6 fw-normal mb-0' style={{color: '#525252'}}>
          Please review your progress.
        </p>
      </div>
      <CustomModal show={showOnboardingModal} onClose={() => {}}>
        <div className='text-center'>
          <div className='mx-auto w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-6 mt-2'>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='45'
              height='45'
              viewBox='0 0 24 24'
              fill='none'
              stroke='#0E9F6E'
              stroke-width='2'
              stroke-linecap='round'
              stroke-linejoin='round'
              className='lucide lucide-circle-check-icon lucide-circle-check'
            >
              <circle cx='12' cy='12' r='10' />
              <path d='m9 12 2 2 4-4' />
            </svg>
          </div>
          <p className='fw-bold mb-5 fs-1 text-gray-900'>Complete Your Setup
          </p>
          <p className='text-gray-900 fs-6 mb-10' >
            Welcome! To unlock your personalized dashboard and access all features, let's complete
            your quick onboarding process.
          </p>
          <div className='d-flex justify-content-center mb-4'>
          <Button btnType='primary' onClick={() => navigate('/onboarding')}>
            Go to Onboarding
          </Button>
          </div>
        </div>
      </CustomModal>
      {currentUser?.role !== 'Auditor' && (
        <DashPageTitle icon='copy-success.svg' title='Employee Onboarding'></DashPageTitle>
      )}
      {/* begin::Row */}
      <DashboardHeader />
      <DashboardPageHeader />

      {/* begin::Row */}
      {currentUser?.role !== 'Auditor' && (
        <div className='row gy-5 gx-xl-12'>
          <div className='col-sm-12 '>
            <TaskList className='card-xxl-stretch mb-4 mb-xl-8' />
          </div>
          {/* <div className='col-sm-4'>
       
          <ActivitiesTable className='card-xxl-stretch mb-4 mb-xl-8'/>
        </div> */}
          {/* <div className='col-xl-4'>
          <div className='row g-5 g-xl-10 mb-5 mb-xl-10'>
            <CardsWidget21
              className='h-md-40 '
              description='Total Assets'
              // color='#0E9F6E'
              // img={toAbsoluteUrl('/media/patterns/vector-1.png')}
            />
            <CardsWidget7
              className='h-md-40 mb-xl-10'
              description='Total Active Personnel'
              icon={false}
              stats={357}
              labelColor='dark'
              textColor='gray-300'
            />
          </div>
        </div> */}
        </div>
      )}
      {/* end::Row */}

      {/* begin::Row */}
      {/* <div className='row gy-5 g-xl-8'>
        <div className='col-xl-4'>
          <ListsWidget2 className='card-xl-stretch mb-xl-8' />
        </div>
        <div className='col-xl-4'>
          <ListsWidget6 className='card-xl-stretch mb-xl-8' />
        </div>
        <div className='col-xl-4'>
          <ListsWidget4 className='card-xl-stretch mb-5 mb-xl-8' items={5} /> */}
      {/* partials/widgets/lists/_widget-4', 'className' => 'card-xl-stretch mb-5 mb-xl-8', 'items' => '5' */}
      {/* </div>
      </div> */}
      {/* end::Row */}

      {/* <div className='row g-5 gx-xxl-8'>
        <div className='col-xxl-4'>
          <MixedWidget8
            className='card-xxl-stretch mb-xl-3'
            chartColor='success'
            chartHeight='150px'
          />
        </div>
        <div className='col-xxl-8'>
          <TablesWidget5 className='card-xxl-stretch mb-5 mb-xxl-8' />
        </div>
      </div> */}
    </>
  )
}

const DashboardWrapper: FC = () => {
  return (
    <>
      <DashboardPage />
    </>
  )
}

export {DashboardWrapper}
